module.exports = require("informed");